// extracted by mini-css-extract-plugin
export default {"container":"page404_container__qLi7h","headline":"page404_headline__ZYiNi","content":"page404_content__9YDyg","button":"page404_button__Sm4jg"};